module.exports = __webpack_public_path__ + "img/Pic_Bottom_Pic1.4f6c43fa.png";